/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { TopByRevenueRequestBuilderRequestsMetadata, type TopByRevenueRequestBuilder } from './topByRevenue/index.js';
// @ts-ignore
import { TrendRequestBuilderRequestsMetadata, type TrendRequestBuilder } from './trend/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/sales-reps
 */
export interface SalesRepsRequestBuilder extends BaseRequestBuilder<SalesRepsRequestBuilder> {
    /**
     * The topByRevenue property
     */
    get topByRevenue(): TopByRevenueRequestBuilder;
    /**
     * The trend property
     */
    get trend(): TrendRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const SalesRepsRequestBuilderUriTemplate = "{+baseurl}/api/analytics/sales-reps";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SalesRepsRequestBuilderNavigationMetadata: Record<Exclude<keyof SalesRepsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    topByRevenue: {
        requestsMetadata: TopByRevenueRequestBuilderRequestsMetadata,
    },
    trend: {
        requestsMetadata: TrendRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
